import React from 'react'

export const IconSearchInput = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9.5" cy="9.52246" r="8.5" stroke="#FFE4D0" strokeWidth="2" />
      <path
        d="M16.2071 15.8154L15.5 15.1082L14.0858 16.5225L14.7929 17.2296L16.2071 15.8154ZM20.2929 22.7296C20.6834 23.1201 21.3166 23.1201 21.7071 22.7296C22.0976 22.339 22.0976 21.7059 21.7071 21.3154L20.2929 22.7296ZM15.5 16.5225L14.7929 17.2296L20.2929 22.7296L21 22.0225L21.7071 21.3154L16.2071 15.8154L15.5 16.5225Z"
        fill="#FFE4D0"
      />
    </svg>
  )
}
